export default class CcBrand {
	private _code: string;
	private _name: string;
	private _position: number;
	private _privateLabel: boolean;
	private _count: number;

	constructor (code: string, name: string, position: number, privateLabel: boolean, count: number = 0) {
		this._code = code;
		this._name = name;
		this._position = position;
		this._privateLabel = privateLabel;
		this._count = count;
	}

	get code (): string {
		return this._code;
	}

	set code (code: string) {
		this._code = code;
	}

	get name (): string {
		return this._name;
	}

	set name (name: string) {
		this._name = name;
	}

	get position (): number {
		return this._position;
	}

	set position (position: number) {
		this._position = position;
	}

	get privateLabel (): boolean {
		return this._privateLabel;
	}

	set privateLabel (privateLabel: boolean) {
		this._privateLabel = privateLabel;
	}

	get count (): number {
		return this._count;
	}

	set count (count: number) {
		this._count = count;
	}
}
